/*
 * @Author: Chao Yang
 * @Date: 2020-09-07 15:37:15
 * @LastEditor: Chao Yang
 * @LastEditTime: 2020-09-07 15:37:25
 */
import { InjectionToken } from '@angular/core';

export const DateRange_Fommat_CONFIG = new InjectionToken<{ format: string }>(
  'data-range-format-config'
);
